import { Fragment } from 'react';

import { ReactComponent as Caution } from 'styles/images/icon_caution.svg';
// 가로 전용 선택 모달
export default function HCPModal({ cpModalData: { mainTitl, popUpButtonList }, closeCpModal }) {
  return (
    <>
      <div className={'modal-msg active'}>
        <div className='modal-msg-box check-name'>
          <div className='msg-box'>
            <Caution />
            <p className='weight-content'>
              {mainTitl.split('\n').map((titl) => (
                <Fragment key={titl}>
                  {titl}
                  <br />
                </Fragment>
              ))}
            </p>
          </div>
          <div className='cmd'>
            {popUpButtonList.map(({ btn_nm, btn_tp, btn_value }, idx) => (
              <Fragment key={`popUpButton_${idx}`}>
                {btn_tp === 'C' ? (
                  <button type='button' className='btn_g3 btn_normal' onClick={closeCpModal}>
                    {btn_nm}
                  </button>
                ) : (
                  <button
                    type='button'
                    className='btn_g3 btn_highlight'
                    onClick={() => {
                      window.location.href = btn_tp === 'W' ? btn_value : `tel:${btn_value}`;
                    }}
                  >
                    {btn_nm}
                  </button>
                )}
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
